module.exports = __webpack_public_path__ + "img/face-smile-tongue.baa4d454.svg";